/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.authManageProfile'

type $nsid = typeof $nsid

export { $nsid }

const main = /*#__PURE__*/ l.permissionSet(
  $nsid,
  [
    /*#__PURE__*/ l.permission('repo', {
      action: ['create', 'update', 'delete'],
      collection: [
        'app.bsky.actor.profile',
        'app.bsky.actor.status',
        'app.bsky.notification.declaration',
      ],
    }),
  ],
  {
    title: 'Manage Bluesky Profile',
    'title:lang': {},
    detail:
      'Update profile data, as well as status and public chat visibility.',
    'detail:lang': {},
  },
)

export { main }
